<template>
    <PublicHome :redirect-to="redirectTo"/>
</template>

<script lang="ts" setup>
import PublicHome from '@/components/PublicHome.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const redirectTo = route.query.redirectTo as string | undefined;



</script>